import { css } from 'styled-components';
import { Primary } from './primary/typography';
import { Cyan } from './cyan/typography';

export const Typography = css`
  ${Primary}
  ${Cyan}
`;
